import React, { useState } from "react";
import styles from "./Table.module.css";
import { MdEmail, MdPhone, MdCalendarToday } from "react-icons/md";
import StatusBadge from "../StatusBadge/StatusBadge";
import ActionMenu from "../ActionMenu/ActionMenu";
import UserAvatar from "../UserAvatar/UserAvatar";
import Pagination from "../../../../OrgEcommerce/Componets/Pagination/Pagination";
import { BiHome } from "react-icons/bi";
import { BsSend, BsWhatsapp } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import TableSkeleton from "./TableSkeleton";
import { IoSettings } from "react-icons/io5";

const Table = ({
  users,
  loading,
  handlePromoteAsAssociate,
  currentPage,
  itemsPerPage,
  setCurrentPage,
  setItemsPerPage,
  totalPage = 1,
  activeTab = "Promoted",
  CustomerType = "Y",
}) => {
  const navigate = useNavigate();
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = users;
  const handlePageSizeChange = (newSize) => {
    setItemsPerPage(newSize);
    setCurrentPage(1);
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Sr.No.</th>
            <th>Customer</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>KYC Status</th>
            <th>Login Status</th>
            <th>Created On</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <TableSkeleton rows={itemsPerPage} />
          ) : currentUsers?.length > 0 ? (
            <>
              {currentUsers?.length > 0
                ? currentUsers?.map((user, i) => {
                    return (
                      <>
                        <tr
                          key={user.CustomerID}
                          style={
                            activeTab === "Promoted"
                              ? { pointerEvents: "none", opacity: "0.6" }
                              : {}
                          }
                        >
                          <td>
                            <ActionMenu
                              i={i}
                              item={user}
                              handlePromoteAsAssociate={() =>
                                handlePromoteAsAssociate({
                                  solutation: user?.Solutation,
                                  name: user?.CustomerName,
                                  mobile:
                                    user?.PrimaryMobile || user?.WhatsappNo,
                                  panno: user?.PanNo,
                                  aadharNo: user?.AdharNo,
                                  emailID: user?.EmailID,
                                  customerID: String(user?.CustomerID),
                                })
                              }
                              CustomerType={CustomerType}
                            />
                          </td>
                          <td className={styles.nameCell}>
                            <UserAvatar
                              src={`${user.ProfileFilePath}${user.ProfileImage}`}
                              alt={user.CustomerName}
                            />
                            <div>
                              <div
                                onClick={() =>
                                  navigate("/customers/customer-details", {
                                    state: {
                                      customerId: user?.CustomerID,
                                    },
                                  })
                                }
                                style={{ cursor: "pointer" }}
                                className={styles.userName}
                              >
                                {user.Solutation} {user.CustomerName}
                              </div>
                              <div className={styles.userCode}>
                                <strong>
                                  {user?.IsPurchaseProperty == 1 ? (
                                    <Link
                                      title={`View booked plot by ${user?.CustomerName}`}
                                      to={"/bookings"}
                                      state={{
                                        customerID: user.CustomerID,
                                      }}
                                    >
                                      {user.CustomerCode}
                                      {user?.IsPurchaseProperty == 1 && (
                                        <BiHome
                                          className="  ms-1 mb-1"
                                          color="#FF27CF"
                                          size={14}
                                          title={`View booked plot by ${user?.CustomerName}`}
                                        />
                                      )}
                                    </Link>
                                  ) : (
                                    user.CustomerCode
                                  )}
                                </strong>{" "}
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className={styles.iconWrapper}>
                              <MdPhone size={14} className={styles.rowIcon} />
                              {user?.PrimaryMobile ? (
                                <a href={`tel:${user.PrimaryMobile}`}>
                                  {user.PrimaryMobile}
                                </a>
                              ) : (
                                "---"
                              )}
                            </div>

                            <div className={styles.iconWrapper}>
                              <BsWhatsapp
                                color="green"
                                size={12}
                                className={styles.rowIcon}
                              />
                              {user?.WhatsappNo ? (
                                <a
                                  href={`https://wa.me/${user.WhatsappNo}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {user.WhatsappNo}
                                </a>
                              ) : (
                                "---"
                              )}
                            </div>
                          </td>
                          <td>
                            {user.EmailID ? (
                              <a
                                href={`mailto:${user.EmailID}`}
                                className={styles.emailLink}
                              >
                                <MdEmail className={styles.rowIcon} />
                                {user.EmailID}
                              </a>
                            ) : (
                              <span className={styles.notAvailable}>N/A</span>
                            )}
                            <div className="">
                              {user.AddressP || user?.StateP ? (
                                <a className={styles.emailLink}>
                                  <BsSend
                                    className={styles.rowIcon}
                                    size={14}
                                  />
                                </a>
                              ) : (
                                <span className={styles.notAvailable}>N/A</span>
                              )}
                            </div>
                          </td>

                          <td>
                            <div className={styles.statusWrapper}>
                              <StatusBadge
                                status={
                                  user.KYCStatus === "Y"
                                    ? "Verified"
                                    : user?.KYCStatus === "P"
                                      ? "Pending"
                                      : user?.KYCStatus === "N" &&
                                        "Not Uploaded"
                                }
                              />
                            </div>
                          </td>

                          <td>
                            <StatusBadge
                              status={
                                user.Status === "Y" ? "Active" : "inactive"
                              }
                            />
                          </td>
                          <td>
                            <div className={styles.iconWrapper}>
                              <MdCalendarToday className={styles.rowIcon} />
                              {user.CreatedOn}
                            </div>
                          </td>
                        </tr>
                      </>
                    );
                  })
                : !loading && (
                    <tr>
                      <td
                        colSpan={7}
                        className={`${styles.noDataCell} ${styles.textDanger}`}
                      >
                        No users found.
                      </td>
                    </tr>
                  )}
            </>
          ) : (
            !loading && (
              <tr>
                <td
                  colSpan={7}
                  className={`${styles.noDataCell} ${styles.textDanger}`}
                >
                  No users found.
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>

      {!loading && (
        <div className={styles.paginationWrapper}>
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={totalPage}
            currentPage={currentPage}
            onPageChange={paginate}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      )}
    </div>
  );
};

export default Table;
